"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./radio-button.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function RadioButton(props) {
  var className = props.className,
      style = props.style,
      label = props.label,
      value = props.value,
      checked = props.checked,
      onClick = props.onClick,
      color = props.color,
      size = props.size,
      rest = _objectWithoutProperties(props, ["className", "style", "label", "value", "checked", "onClick", "color", "size"]);

  var wrapperClassName = (0, _classnames.default)('block flex items-center cursor-pointer', className);
  return _react.default.createElement("label", {
    className: wrapperClassName,
    style: style,
    htmlFor: value,
    onClick: onClick
  }, _react.default.createElement("div", {
    className: "relative mr-2 rounded-full",
    style: {
      border: "".concat(size / 8, "px solid ").concat(color),
      width: size,
      height: size
    }
  }, _react.default.createElement("input", _extends({
    className: "opacity-0",
    type: "radio",
    value: value,
    checked: checked,
    onChange: onClick
  }, rest)), _react.default.createElement("div", {
    className: "radio-checked absolute rounded-full",
    style: {
      backgroundColor: color,
      width: Math.round(size / 2.2),
      height: Math.round(size / 2.2),
      top: '50%',
      left: '50%',
      transform: "translate(-50%, -50%) scale(".concat(checked ? 1 : 0, ")")
    }
  })), _react.default.createElement("span", null, label));
}

RadioButton.propTypes = {
  className: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  checked: _propTypes.default.bool.isRequired,
  color: _propTypes.default.string,
  size: _propTypes.default.number
};
RadioButton.defaultProps = {
  className: '',
  color: '#43484D',
  size: 16
};

var _default = _react.default.memo(RadioButton);

exports.default = _default;